import type { ReactNode } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

interface EmptyStateProps {
  icon?: IconDefinition;
  title: string;
  description?: string;
  /** Usually a `<Button>` that starts the flow which fills this list. */
  action?: ReactNode;
  className?: string;
}

export default function EmptyState({ icon, title, description, action, className = '' }: EmptyStateProps) {
  return (
    <div className={`text-center py-12 px-4 ${className}`}>
      {icon !== undefined && (
        <FontAwesomeIcon icon={icon} className="w-10 h-10 text-gray-300 dark:text-gray-600 mb-3" />
      )}
      <p className="text-base font-medium text-gray-900 dark:text-white">{title}</p>
      {description !== undefined && (
        <p className="mt-1 text-sm text-gray-500 dark:text-gray-400 max-w-md mx-auto">{description}</p>
      )}
      {action !== undefined && <div className="mt-4 flex justify-center">{action}</div>}
    </div>
  );
}
